module.exports = __webpack_public_path__ + "img/sv_get.7f9d410.png";